import { Injectable } from '@angular/core';
import { HttpService } from '@core/services/http/http.service';
import { URLParamsService } from '@shared/services/url-params.service';
import { BranchViewModel } from '@shared/models/branch-view.model';
import { Orders } from '@shared/models/orders';
import { DeliveryViewModel } from '@shared/models/delivery-view.model';
import { OrderAssigment } from '@shared/interfaces/order-assigment';
import { DeliveryAssigment } from '@shared/interfaces/delivery-assigment';
import { OrderDetail } from '../models/order-detail';
import { Observable } from 'rxjs';

@Injectable()
export class OrdersAssignmentService {
  static readonly url = 'OrdersAssignments/';
  private cached: any[] = [];

  constructor(private httpService: HttpService) { }

  getAllBranches(restaurantType: string): Observable<BranchViewModel[]> {
    const url = URLParamsService.buildUrl(
      `${OrdersAssignmentService.url}GetAllBranches`,
      {
        restaurantType: restaurantType
      }
    );

    return this.httpService.GetRequest<BranchViewModel[]>(url
    );
  }
  
  getBranches(restaurantType: string): Observable<BranchViewModel[]> {
    const url = URLParamsService.buildUrl(
      `${OrdersAssignmentService.url}GetBranches`,
      {
        restaurantType: restaurantType
      }
    );

    return this.httpService.GetRequest<BranchViewModel[]>(url
    );
  }

  getOrdersProcessByBranch(branchId: number): Observable<Orders[]> {
    const url = URLParamsService.buildUrl(
      `${OrdersAssignmentService.url}getOrders`,
      {
        BranchID: branchId
      }
    );

    return this.httpService.GetRequest<Orders[]>(
      url
    );
  }

  getDeliveries(branchId: number): Observable<DeliveryViewModel[]> {
    const url = URLParamsService.buildUrl(
      `${OrdersAssignmentService.url}GetDeliveries`,
      {
        BranchID: branchId
      }
    );

    return this.httpService.GetRequest<DeliveryViewModel[]>(
      url
    );
  }

  changeOrderAssigned(orderAssignment: OrderAssigment): Observable<any> {
    const url = `${OrdersAssignmentService.url}ChangeAssignedOrder`;

    return this.httpService.PostRequest<OrderAssigment, any>(url, orderAssignment);
  }

  changeDeliveryAssigned(deliveryAssingment: DeliveryAssigment): Observable<any> {
    const url = `${OrdersAssignmentService.url}ChangeAssignedDelivery`;

    return this.httpService.PostRequest<DeliveryAssigment, any>(url, deliveryAssingment);
  }

  getOrdersPriority(branchId: number, channel?: number, orderType?: number): Observable<Orders[]> {
    const url = URLParamsService.buildUrl(
      `${OrdersAssignmentService.url}getOrdersPriority`,
      {
        branchId: branchId,
        channel: channel,
        orderType: orderType
      }
    );

    return this.httpService.GetRequest<Orders[]>(
      url
    );
  }

  getOrdersDetail(orderID?: number): Promise<OrderDetail[]> {
    const url = URLParamsService.buildUrl(
      `${OrdersAssignmentService.url}getOrderDetail`,
      {
        orderID: orderID
      }
    );

    return new Promise((resolve, reject) => {

      if (this.cached && this.cached.find(b => b.orderID === orderID)) {
        return resolve(this.cached.find(b => b.orderID === orderID).data);
      }

      this.httpService.GetRequest<OrderDetail[]>(url).subscribe((data) => {
        this.cached.push({
          orderID: orderID,
          data: data
        });
        resolve(data);
      }, (error) => reject(error));
    });
  }
}
